import axios from 'axios'
export const api = {
  postApi(u, postParams, headers = {}) {
    return axios({
      method: 'post',
      url: '/platform/api/v1' + u,
      data: postParams,
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        'Content-Type': 'application/json',
        ...headers
      }
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  getApi(u, getParams, headers = {}) {
    return axios({
      method: 'get',
      url: '/platform/api/v1' + u,
      params: getParams,
      headers
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  getApiSpecil(u, getParams) {
    return axios({
      method: 'get',
      url: u,
      params: getParams
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  putApi(u, postParams) {
    return axios({
      method: 'put',
      url: '/platform/api/v1' + u,
      data: postParams,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  deleteApi(u, postParams) {
    return axios({
      method: 'delete',
      url: '/platform/api/v1' + u,
      data: postParams,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  postApi_header(u, tokens, postParams) {
    const { token, userId } = sessionStorage.getItem('userInfo')
      ? sessionStorage.getItem('userInfo')
      : {}
    return axios({
      method: 'post',
      url: '/platform/api/v1' + u,
      headers: { token: token, uid: userId },
      data: postParams
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  getApi_header(u, params) {
    const { token, userId } = sessionStorage.getItem('userInfo')
      ? sessionStorage.getItem('userInfo')
      : {}
    return axios({
      method: 'get',
      url: '/platform/api/v1' + u,
      headers: { token: token, uid: userId },
      params: params
    })
      .then(res => {
        if (res.status === 200) {
          return res.data
        } else {
          return {}
        }
      })
      .catch(err => {
        return {
          err
        }
      })
  },
  postApi_www(u, postParams) {
    return axios({
      method: 'post',
      url: '/platform/api/v1' + u,
      transformRequest: [
        function(data) {
          // Do whatever you want to transform the data
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: postParams
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  getApi_file(u, getParams) {
    return axios({
      method: 'get',
      url: '/platform/api/v1' + u,
      params: getParams,
      responseType: 'blob'
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  postApi_file(u, postParams) {
    return axios({
      method: 'post',
      url: '/platform/api/v1' + u,
      data: postParams,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  postApiSpecil(u, postParams) {
    return axios({
      method: 'post',
      url: u,
      data: postParams,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  },
  NewGetApi_file(u, getParams) {
    return axios({
      method: 'get',
      url: '/platform/api/v1' + u,
      params: getParams,
      responseType: 'blob'
    })
      .then(res => res)
      .catch(err => {
        console.log('error', err)
      })
  }
}
export default api
